import React from 'react';
import { useTranslation } from 'react-i18next';
import OpenDashboardForm from './openDashboardForm';

function OpenDashboard()
{
  const { t } = useTranslation();
  
  return(
    <div className="dashboard-container open-screen">
      <div className="content-wrapper">
        <h3 className="mm-logo">MedievalMe</h3>
        <h3 className="digiboard-h3">{ t("digiboard.open.title") }</h3>
        <OpenDashboardForm />
      </div>
    </div>
  )
}

export default OpenDashboard;